// Copyright (c) 2025 Audere, All Rights Reserved

export const UPLOAD_TEST_ITEM_HEIGHT = 80;
export const UPLOAD_TEST_ITEM_MAX_HEIGHT = 400;

// Path constants
export const CREATE_PROJECT_WITH_TEST_PATH = "/organization/:orgUid/projects/create/test/:testUid";
export const UPDATE_PROJECT_WITH_TEST_PATH =
  "/organization/:orgUid/projects/:projectUid/test/:testUid";
export const CREATE_PROJECT_WITHOUT_TEST_PATH = "/organization/:orgUid/projects/create";
export const UPDATE_PROJECT_WITHOUT_TEST_PATH = "/organization/:orgUid/projects/:projectUid";
export const DASHBOARD_PATH = "/organization/:orgUid/dashboard/projects/:projectUid/test/:testUid";
export const MANAGE_SDK_PATH = "/organization/:orgUid/projects/:projectUid/manage-sdk";

export const POSITIVE_LABEL = "positive";
